module.exports = __webpack_public_path__ + "img/avatar3.461d554c.png";